import { render, staticRenderFns } from "./OntologyTree.vue?vue&type=template&id=75e24913&scoped=true&"
import script from "./OntologyTree.vue?vue&type=script&lang=js&"
export * from "./OntologyTree.vue?vue&type=script&lang=js&"
import style0 from "./OntologyTree.vue?vue&type=style&index=0&id=75e24913&scoped=true&lang=css&"
import style1 from "./OntologyTree.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e24913",
  null
  
)

export default component.exports